import { useQuery, gql } from "@apollo/client"
import { INTEGRATION_PROVIDER_FIELDS } from "./useQueryIntegrationProviders"

const INTEGRATION_FIELDS = `
  id
  integrationProvider { ${INTEGRATION_PROVIDER_FIELDS} }
  variables { 
    name
    description
    key
  }
  enabled
  enabledAt
  paused
  pausedAt
  events
  createdAt
`

const INTEGRATION_QUERY = gql`
  query Integrations {
    integrations {
      ${INTEGRATION_FIELDS}
    }
  }
`

const useQueryIntegrations = () => useQuery(INTEGRATION_QUERY)

export { useQueryIntegrations, INTEGRATION_FIELDS }
